// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ninput[data-v-40660bae]:-webkit-autofill,\ninput[data-v-40660bae]:-webkit-autofill:hover, \ninput[data-v-40660bae]:-webkit-autofill:focus, \ninput[data-v-40660bae]:-webkit-autofill:active {\n    transition: background-color 5000s ease-in-out 0s;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
